import React, { useDebugValue, useEffect, useState } from "react";
import loginLogo from "../../assets/images/login-signup/loginLogo.png";
import loginImg from "../../assets/images/login-signup/login.png";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { ToastContainer, toast } from "react-toastify";
import { object, string } from "yup";
import { axiosInstance } from "../../axiosInstance";

let LoginSchema = object({
  email: string()
    .email("Invalid email address (must include '@')")
    .required("Email is required"),
  password: string().required("Password is required"),
});

export function Login() {
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      userType: "USER",
    },
    validationSchema: LoginSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        const formattedValues = {
          ...values,
        };

        const { data } = await axiosInstance.post("/login", formattedValues);

        if (data.status === 200) {
          toast.success(data.message || "Login Successfully!");
          localStorage.setItem("token", data.data[0].token);
          localStorage.setItem("user_id", data.data[0].user_id);

          resetForm();
          setTimeout(() => {
            navigate("/");
          }, 3000);
        } else {
          toast.error("Something went wrong, please try again!");
        }
      } catch (error) {
        console.error("Submission failed:", error);
        toast.error("Submission failed! Please try again.");
      }
    },
  });
  return (
    <>
      <ToastContainer />
      <div className="login-container container">
        <div className="login-subcontainer">
          <div className="login-left">
            <div className="login-logo">
              <img src={loginLogo} />
            </div>

            <form onSubmit={formik.handleSubmit}>
              <div className="loginForm-container">
                <div className="login-title">Log in</div>
                <div className="login-field">
                  <label for="email">Email Address</label>
                  <div>
                    <input
                      type="text"
                      placeholder="Enter your email address"
                      id="email"
                      onChange={formik.handleChange}
                      value={formik.values.email}
                    />
                  </div>
                  {formik.touched.email && formik.errors.email && (
                    <div className="formError">{formik.errors.email}</div>
                  )}
                </div>
                <div className="login-field">
                  <label for="password">Password</label>
                  <div>
                    <input
                      type="password"
                      placeholder="Enter your password"
                      id="password"
                      onChange={formik.handleChange}
                      value={formik.values.password}
                    />
                  </div>
                  {formik.touched.password && formik.errors.password && (
                    <div className="formError">{formik.errors.password}</div>
                  )}
                </div>
                <div className="textForgot">
                  <Link to="/forgot"> Forgot password</Link>
                </div>
                <div className="btnLogin">
                  <button>Log in</button>
                </div>
                <div className="btnCreate">
                  <Link to="/signup">
                    <button>Create an account</button>
                  </Link>
                </div>
              </div>
            </form>
          </div>
          <div className="login-right">
            <div>
              <img src={loginImg} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
